// extracted by mini-css-extract-plugin
module.exports = {"infoItem":"GeneralInfo_infoItem__elVey","infoContent":"GeneralInfo_infoContent__qtukf"};